var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoodQuality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8405 3.90181C14.0182 3.79568 13.292 3.98671 12.7447 4.48862C10.5593 6.49274 8.01258 9.075 6.12126 10.9927C5.54783 11.5742 5.03462 12.0945 4.61002 12.5191C3.33892 13.7903 3.32786 14.7449 3.485 15.3751C3.68219 16.166 4.26444 16.8546 4.67934 17.2279L4.69894 17.2456L9.91599 22.2408C10.5947 22.8908 10.6181 23.9677 9.96825 24.6462C9.31839 25.3251 8.24138 25.3486 7.5627 24.6986L2.38241 19.7384C1.73044 19.1472 0.610282 17.9106 0.183338 16.1984C-0.288251 14.3071 0.165235 12.1518 2.20383 10.1131C2.60107 9.71584 3.09243 9.21754 3.64891 8.65326C5.5418 6.73376 8.18803 4.05034 10.4449 1.98072C11.8722 0.67181 13.6648 0.319114 15.276 0.527023C16.8617 0.731631 18.3808 1.48504 19.4642 2.55922C20.2707 3.3589 21.2036 4.25795 22.1094 5.1296L22.2526 5.26738C23.102 6.08486 23.9227 6.87464 24.5634 7.50986C25.2307 8.17143 25.2352 9.24868 24.5737 9.91596C23.9122 10.5832 22.8348 10.5878 22.1676 9.92623C21.5459 9.30958 20.7421 8.53624 19.8838 7.71032L19.7499 7.58139C18.8471 6.71263 17.8959 5.79606 17.0684 4.97559C16.5177 4.42962 15.6884 4.01121 14.8405 3.90181Z",
    fill: "#5F4982"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8405 3.90181C14.0182 3.79568 13.292 3.98671 12.7447 4.48862C10.5593 6.49274 8.01258 9.075 6.12126 10.9927C5.54783 11.5742 5.03462 12.0945 4.61002 12.5191C3.33892 13.7903 3.32786 14.7449 3.485 15.3751C3.68219 16.166 4.26444 16.8546 4.67934 17.2279L4.69894 17.2456L9.91599 22.2408C10.5947 22.8908 10.6181 23.9677 9.96825 24.6462C9.31839 25.3251 8.24138 25.3486 7.5627 24.6986L2.38241 19.7384C1.73044 19.1472 0.610282 17.9106 0.183338 16.1984C-0.288251 14.3071 0.165235 12.1518 2.20383 10.1131C2.60107 9.71584 3.09243 9.21754 3.64891 8.65326C5.5418 6.73376 8.18803 4.05034 10.4449 1.98072C11.8722 0.67181 13.6648 0.319114 15.276 0.527023C16.8617 0.731631 18.3808 1.48504 19.4642 2.55922C20.2707 3.3589 21.2036 4.25795 22.1094 5.1296L22.2526 5.26738C23.102 6.08486 23.9227 6.87464 24.5634 7.50986C25.2307 8.17143 25.2352 9.24868 24.5737 9.91596C23.9122 10.5832 22.8348 10.5878 22.1676 9.92623C21.5459 9.30958 20.7421 8.53624 19.8838 7.71032L19.7499 7.58139C18.8471 6.71263 17.8959 5.79606 17.0684 4.97559C16.5177 4.42962 15.6884 4.01121 14.8405 3.90181Z",
    fill: "url(#paint0_radial_1714_6105)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00186 18.9989C5.00186 18.9989 5.50703 19.5308 3.38021 17.3774C1.25338 15.2241 2.30439 13.3565 3.38021 12.0606C4.54994 10.6516 9.34385 6.08791 12.0731 3.39408C12.9164 2.5618 15.3712 0.964815 17.9216 3.10165C19.397 4.33777 20.1768 5.17968 20.8856 5.85315",
    stroke: "url(#paint1_linear_1714_6105)",
    strokeWidth: 0.893239,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7424 69.4786C74.3161 68.8974 74.8292 68.3768 75.2539 67.9521C76.5248 66.6812 76.5361 65.7267 76.3789 65.0961C76.1815 64.3053 75.5993 63.6166 75.1845 63.2433L75.1648 63.2257L69.9476 58.2307C69.2691 57.5808 69.2457 56.5038 69.8956 55.825C70.5455 55.1465 71.6225 55.123 72.301 55.7729L77.4814 60.7328C78.1333 61.3242 79.2535 62.5607 79.6806 64.273C80.1522 66.1643 79.6986 68.3196 77.66 70.3582C77.2626 70.7556 76.7712 71.2538 76.2149 71.818C74.3219 73.7375 71.6759 76.4209 69.4189 78.4908C67.9914 79.7995 66.1988 80.1523 64.5876 79.9444C63.0019 79.7396 61.4829 78.9862 60.3995 77.9123C59.593 77.1123 58.66 76.2133 57.7542 75.3419L57.6113 75.204C56.7616 74.3867 55.9409 73.5969 55.3005 72.9616C54.6332 72.2998 54.6284 71.2228 55.2899 70.5555C55.9517 69.8883 57.0291 69.8835 57.696 70.545C58.318 71.1616 59.1214 71.935 59.9796 72.7609L60.114 72.8898C61.0168 73.7589 61.9678 74.6753 62.7954 75.4957C63.3459 76.0418 64.1755 76.46 65.0232 76.5696C65.8456 76.6757 66.5718 76.4845 67.1189 75.9826C69.3045 73.9787 71.8512 71.3964 73.7424 69.4786Z",
    fill: "#513D75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0676 58.9283C74.0676 58.9283 75.1034 59.8369 77.2301 61.9901C79.3572 64.1434 78.5194 66.3035 77.4435 67.5992C76.2739 69.0083 71.4801 73.5721 68.7508 76.2661C67.9076 77.098 65.2391 78.4027 62.6888 76.2661C61.2133 75.0298 60.4337 74.188 59.7246 73.5146",
    stroke: "url(#paint2_linear_1714_6105)",
    strokeWidth: 0.893239,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.899 78.175C62.4865 78.175 79.9866 60.675 79.9866 39.0875C79.9866 17.5001 62.4865 0 40.899 0C19.3116 0 1.81152 17.5001 1.81152 39.0875C1.81152 60.675 19.3116 78.175 40.899 78.175Z",
    fill: "url(#paint3_linear_1714_6105)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8987 76.3495C61.4779 76.3495 78.1606 59.6667 78.1606 39.0875C78.1606 18.5083 61.4779 1.82559 40.8987 1.82559C20.3195 1.82559 3.63672 18.5083 3.63672 39.0875C3.63672 59.6667 20.3195 76.3495 40.8987 76.3495Z",
    fill: "url(#paint4_linear_1714_6105)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8987 76.3495C61.4779 76.3495 78.1606 59.6667 78.1606 39.0875C78.1606 18.5083 61.4779 1.82559 40.8987 1.82559C20.3195 1.82559 3.63672 18.5083 3.63672 39.0875C3.63672 59.6667 20.3195 76.3495 40.8987 76.3495Z",
    fill: "url(#paint5_radial_1714_6105)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8999 69.544C57.7206 69.544 71.3564 55.9081 71.3564 39.0875C71.3564 22.2668 57.7206 8.63095 40.8999 8.63095C24.0792 8.63095 10.4434 22.2668 10.4434 39.0875C10.4434 55.9081 24.0792 69.544 40.8999 69.544Z",
    fill: "url(#paint6_radial_1714_6105)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8999 69.544C57.7206 69.544 71.3564 55.9081 71.3564 39.0875C71.3564 22.2668 57.7206 8.63095 40.8999 8.63095C24.0792 8.63095 10.4434 22.2668 10.4434 39.0875C10.4434 55.9081 24.0792 69.544 40.8999 69.544Z",
    fill: "url(#paint7_radial_1714_6105)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.675 62.5434C42.2751 62.5434 44.8901 64.0573 47.2778 63.3145C49.719 62.5186 51.11 59.4568 53.1796 57.9711C55.2491 56.4855 58.1537 56.1326 59.6663 54.0896C61.5357 51.5641 60.9001 48.0099 61.696 45.5691C62.4654 43.2076 64.7435 41.5372 64.7435 38.8837C64.7435 36.2836 62.1901 33.3906 61.4207 31.0294C60.6248 28.5883 61.5422 26.0594 60.0116 23.917C58.2623 21.4677 55.1961 21.1757 53.1265 19.6901C51.11 18.2041 50.112 15.4134 47.1451 14.4466C44.1779 13.4799 41.9028 15.1176 39.2497 15.1176C36.6493 15.1176 34.884 13.37 31.5819 14.4466C29.1411 15.2426 27.5486 18.2041 25.4791 19.6901C23.4095 21.1757 20.5444 21.5041 19.0322 23.5471C17.2911 25.8991 18.0871 28.8398 17.2911 31.2806C16.5217 33.6421 14.0479 36.204 14.0479 38.8571C14.0479 41.4572 16.2463 43.5935 17.0157 45.955C17.8117 48.3961 17.0157 51.5644 19.152 54.143C20.6379 56.2123 23.4095 56.2725 25.4791 57.7585C27.4955 59.2441 29.0993 62.5186 31.5401 63.3145C33.9547 64.0839 37.0746 62.5434 39.675 62.5434Z",
    fill: "#393138"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0501 62.5434C43.6501 62.5434 46.2651 64.0573 48.6529 63.3145C51.094 62.5186 52.4851 59.4568 54.5546 57.9711C56.6242 56.4855 59.5288 56.1326 61.0413 54.0896C62.9108 51.5641 62.2751 48.0099 63.071 45.5691C63.8404 43.2076 66.1186 41.5372 66.1186 38.8837C66.1186 36.2836 63.5651 33.3906 62.7958 31.0294C61.9999 28.5883 62.9172 26.0594 61.3867 23.917C59.6373 21.4677 56.5711 21.1757 54.5015 19.6901C52.4851 18.2041 51.487 15.4134 48.5202 14.4466C45.5529 13.4799 43.2779 15.1176 40.6247 15.1176C38.0243 15.1176 36.259 13.37 32.9569 14.4466C30.5161 15.2426 28.9236 18.2041 26.8541 19.6901C24.7845 21.1757 21.9194 21.5041 20.4072 23.5471C18.6661 25.8991 19.4621 28.8398 18.6661 31.2806C17.8967 33.6421 15.4229 36.204 15.4229 38.8571C15.4229 41.4572 17.6213 43.5935 18.3907 45.955C19.1867 48.3961 18.3907 51.5644 20.527 54.143C22.0126 56.2123 24.7845 56.2725 26.8541 57.7585C28.8706 59.2441 30.4743 62.5186 32.9151 63.3145C35.3297 64.0839 38.4497 62.5434 41.0501 62.5434Z",
    fill: "url(#paint8_linear_1714_6105)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0341 61.2565C43.4933 61.2565 45.9664 62.6884 48.2248 61.9857C50.5336 61.233 51.8491 58.3373 53.8064 56.9323C55.7636 55.5269 58.511 55.1935 59.9412 53.2614C61.7096 50.8726 61.1084 47.5111 61.861 45.2026C62.5889 42.9694 64.7435 41.3891 64.7435 38.8799C64.7435 36.4208 62.3282 33.6846 61.6007 31.4514C60.8477 29.1429 61.7154 26.7511 60.2682 24.7248C58.6135 22.4082 55.7136 22.1322 53.7563 20.7269C51.8491 19.3218 50.9052 16.6824 48.0993 15.768C45.293 14.8537 43.1411 16.4027 40.6319 16.4027C38.1727 16.4027 36.503 14.7498 33.3799 15.768C31.0715 16.5208 29.5654 19.3218 27.6082 20.7269C25.6509 22.1322 22.9413 22.4429 21.5108 24.375C19.8643 26.5994 20.6172 29.3805 19.8643 31.6892C19.1365 33.9225 16.7969 36.3456 16.7969 38.8548C16.7969 41.3139 18.8761 43.3345 19.6038 45.5677C20.3565 47.8762 19.6038 50.873 21.6241 53.3114C23.0294 55.2687 25.6509 55.3255 27.6082 56.7308C29.5151 58.1362 31.032 61.233 33.3405 61.9857C35.6241 62.7136 38.5749 61.2565 41.0341 61.2565Z",
    fill: "url(#paint9_linear_1714_6105)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8299 27.755C44.8089 28.734 46.3963 28.734 47.3753 27.755C48.3542 26.776 48.3542 25.189 47.3753 24.21C46.3963 23.231 44.8089 23.231 43.8299 24.21C42.851 25.189 42.851 26.776 43.8299 27.755Z",
    fill: "#B36D31"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0487 45.5663C22.0277 46.5453 23.6148 46.5453 24.5937 45.5663C25.5727 44.5874 25.5727 43.0003 24.5937 42.0213C23.6148 41.0424 22.0277 41.0424 21.0487 42.0213C20.0697 43.0003 20.0697 44.5874 21.0487 45.5663Z",
    fill: "#B36D31"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1483 55.5797C49.1273 56.5586 50.7143 56.5586 51.6933 55.5797C52.6723 54.6007 52.6723 53.0133 51.6933 52.0343C50.7143 51.0554 49.1273 51.0554 48.1483 52.0343C47.1693 53.0133 47.1693 54.6007 48.1483 55.5797Z",
    fill: "#B36D31"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6023 27.3569C45.5812 28.3358 47.1686 28.3358 48.1476 27.3569C49.1266 26.3779 49.1266 24.7908 48.1476 23.8119C47.1686 22.8329 45.5812 22.8329 44.6023 23.8119C43.6233 24.7908 43.6236 26.3779 44.6023 27.3569Z",
    fill: "#C9433E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6023 27.3569C45.5812 28.3358 47.1686 28.3358 48.1476 27.3569C49.1266 26.3779 49.1266 24.7908 48.1476 23.8119C47.1686 22.8329 45.5812 22.8329 44.6023 23.8119C43.6233 24.7908 43.6236 26.3779 44.6023 27.3569Z",
    fill: "url(#paint10_radial_1714_6105)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8426 55.1638C49.8216 56.1428 51.409 56.1428 52.388 55.1638C53.3669 54.1849 53.3669 52.5975 52.388 51.6185C51.409 50.6395 49.8216 50.6395 48.8426 51.6185C47.8637 52.5975 47.8637 54.1849 48.8426 55.1638Z",
    fill: "#C9433E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8426 55.1638C49.8216 56.1428 51.409 56.1428 52.388 55.1638C53.3669 54.1849 53.3669 52.5975 52.388 51.6185C51.409 50.6395 49.8216 50.6395 48.8426 51.6185C47.8637 52.5975 47.8637 54.1849 48.8426 55.1638Z",
    fill: "url(#paint11_radial_1714_6105)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6747 45.2748C22.6533 46.2538 24.2407 46.2538 25.2197 45.2748C26.1987 44.2958 26.1987 42.7084 25.2197 41.7294C24.2407 40.7505 22.6533 40.7505 21.6744 41.7294C20.6957 42.7084 20.6957 44.2958 21.6747 45.2748Z",
    fill: "#C9433E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6747 45.2748C22.6533 46.2538 24.2407 46.2538 25.2197 45.2748C26.1987 44.2958 26.1987 42.7084 25.2197 41.7294C24.2407 40.7505 22.6533 40.7505 21.6744 41.7294C20.6957 42.7084 20.6957 44.2958 21.6747 45.2748Z",
    fill: "url(#paint12_radial_1714_6105)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5355 33.5836C52.7796 33.7108 53.685 34.8222 53.5581 36.0662L52.6816 44.6469C52.5543 45.891 51.0441 46.8839 49.8001 46.757C48.556 46.6301 47.6506 45.5184 47.7775 44.2744L48.654 35.6936C48.7813 34.4496 50.2915 33.4566 51.5355 33.5836Z",
    fill: "#9D7B30"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1061 33.2382C53.3502 33.3651 54.2557 34.4768 54.1288 35.7208L53.2522 44.3016C53.1249 45.5456 52.0136 46.4511 50.7695 46.3239C49.5255 46.1969 48.62 45.0852 48.7473 43.8412L49.6238 35.2604C49.7508 34.0164 50.8621 33.1109 52.1061 33.2382Z",
    fill: "url(#paint13_linear_1714_6105)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1061 33.2382C53.3502 33.3651 54.2557 34.4768 54.1288 35.7208L53.2522 44.3016C53.1249 45.5456 52.0136 46.4511 50.7695 46.3239C49.5255 46.1969 48.62 45.0852 48.7473 43.8412L49.6238 35.2604C49.7508 34.0164 50.8621 33.1109 52.1061 33.2382Z",
    fill: "url(#paint14_radial_1714_6105)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1027 26.3442C38.5103 27.5478 37.8652 28.8541 36.6616 29.2617L28.3602 32.0748C27.1567 32.4828 25.8504 31.8376 25.4427 30.6341C25.0347 29.4305 25.6799 28.1242 26.8834 27.7165L35.1848 24.9035C36.3884 24.4958 37.6947 25.1406 38.1027 26.3442Z",
    fill: "url(#paint15_linear_1714_6105)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1815 26.4888C38.5895 27.6924 37.8647 28.8395 36.6612 29.2471L25.8169 32.8227C24.6134 33.2304 23.3867 32.7448 22.9787 31.5413C22.571 30.3377 23.2162 29.0314 24.4198 28.6237L35.264 25.0481C36.4676 24.6405 37.7739 25.2856 38.1815 26.4888Z",
    fill: "url(#paint16_linear_1714_6105)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M38.182 26.2094C38.59 27.4129 38.034 28.2459 36.8304 28.6539L28.529 31.4666C27.3255 31.8746 25.7731 31.8195 25.3655 30.616C24.9575 29.4124 25.9092 28.5202 27.1128 28.1122L35.4142 25.2995C36.6177 24.8915 37.7743 25.0058 38.182 26.2094Z",
    fill: "#A27932"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0469 25.946C39.4546 27.1496 38.8097 28.4559 37.6062 28.8635L29.3045 31.6766C28.1009 32.0846 26.7949 31.4394 26.3869 30.2359C25.9793 29.0323 26.6241 27.726 27.8277 27.3183L36.1294 24.5053C37.3326 24.0976 38.6389 24.7424 39.0469 25.946Z",
    fill: "url(#paint17_linear_1714_6105)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0469 25.946C39.4546 27.1496 38.8097 28.4559 37.6062 28.8635L29.3045 31.6766C28.1009 32.0846 26.7949 31.4394 26.3869 30.2359C25.9793 29.0323 26.6241 27.726 27.8277 27.3183L36.1294 24.5053C37.3326 24.0976 38.6389 24.7424 39.0469 25.946Z",
    fill: "url(#paint18_radial_1714_6105)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0469 25.946C39.4546 27.1496 38.8097 28.4559 37.6062 28.8635L29.3045 31.6766C28.1009 32.0846 26.7949 31.4394 26.3869 30.2359C25.9793 29.0323 26.6241 27.726 27.8277 27.3183L36.1294 24.5053C37.3326 24.0976 38.6389 24.7424 39.0469 25.946Z",
    fill: "url(#paint19_radial_1714_6105)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37.447 26.4344L28.7227 29.3747",
    stroke: "url(#paint20_linear_1714_6105)",
    strokeWidth: 0.893239,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0578 55.3276C39.1547 56.2218 37.698 56.2147 36.8038 55.3116L30.6366 49.0832C29.7424 48.1801 29.7498 46.7234 30.6526 45.8291C31.5557 44.9352 33.0124 44.9424 33.9067 45.8455L40.0738 52.0739C40.9681 52.9766 40.9606 54.4337 40.0578 55.3276Z",
    fill: "#A07A34"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0079 54.7337C40.1048 55.6277 38.648 55.6205 37.7538 54.7174L31.5866 48.489C30.6927 47.5862 30.6999 46.1292 31.603 45.2353C32.5057 44.341 33.9628 44.3482 34.8567 45.2513L41.0239 51.4797C41.9181 52.3828 41.911 53.8395 41.0079 54.7337Z",
    fill: "url(#paint21_linear_1714_6105)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0079 54.7337C40.1048 55.6277 38.648 55.6205 37.7538 54.7174L31.5866 48.489C30.6927 47.5862 30.6999 46.1292 31.603 45.2353C32.5057 44.341 33.9628 44.3482 34.8567 45.2513L41.0239 51.4797C41.9181 52.3828 41.911 53.8395 41.0079 54.7337Z",
    fill: "url(#paint22_radial_1714_6105)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9602 35.2151L51.8965 44.3601",
    stroke: "url(#paint23_linear_1714_6105)",
    strokeWidth: 0.893239,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0098 26.4956L27.918 29.5795",
    stroke: "url(#paint24_linear_1714_6105)",
    strokeWidth: 0.893239,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6367 46.0088L40.2537 52.4101",
    stroke: "url(#paint25_linear_1714_6105)",
    strokeWidth: 0.893239,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2033 30.1022C25.8491 29.0371 27.5321 27.333 27.5321 27.333C27.2129 29.8851 29.1538 31.7593 29.1538 31.7593C28.6162 31.909 26.5575 31.1676 26.2033 30.1022Z",
    fill: "url(#paint26_linear_1714_6105)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5299 45.2714C32.3074 44.4622 34.5992 45.1577 34.5992 45.1577C31.0276 45.6096 31.4377 48.6541 31.4377 48.6541C31.0545 48.2481 30.752 46.0809 31.5299 45.2714Z",
    fill: "url(#paint27_linear_1714_6105)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M50.652 46.2452C49.5356 46.1285 48.6777 43.8926 48.6777 43.8926C51.2274 46.4341 53.3787 44.241 53.3787 44.241C53.2932 44.7926 51.7688 46.3623 50.652 46.2452Z",
    fill: "url(#paint28_linear_1714_6105)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M48.918 16.0746C50.7789 16.9253 51.2043 19.1052 53.2248 20.6472C55.1981 22.153 58.1646 22.4793 59.605 24.2623C60.7215 25.6449 61.253 27.0839 61.253 31.7062C61.253 33.7795 63.1139 35.5343 64.3369 36.9165",
    stroke: "url(#paint29_linear_1714_6105)",
    strokeWidth: 0.893239,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1714_6105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5191 13.6289) rotate(135.141) scale(15.2262 3.75975)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439333,
    stopColor: "#332D3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1714_6105",
    x1: 2.14844,
    y1: 15.6493,
    x2: 16.3267,
    y2: 0.868551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A69A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27686,
    stopColor: "#7456A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831809,
    stopColor: "#654D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B69A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1714_6105",
    x1: 78.4619,
    y1: 63.7184,
    x2: 64.2836,
    y2: 78.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A69A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27686,
    stopColor: "#7456A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831809,
    stopColor: "#654D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B69A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1714_6105",
    x1: 70.6998,
    y1: 15.2173,
    x2: 9.4201,
    y2: 62.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E75BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506319,
    stopColor: "#58457C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D3966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1714_6105",
    x1: 71.8563,
    y1: 14.9598,
    x2: 14.5782,
    y2: 65.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E50A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448599,
    stopColor: "#5C4385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D3F7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1714_6105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.8613 41.5954) rotate(82.4465) scale(61.1422 61.1422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.309957,
    stopColor: "#B5A4CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.430675,
    stopColor: "#7E6898",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1714_6105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1739 40.9743) rotate(-3.39134) scale(57.2062)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#654B7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465717,
    stopColor: "#4D3A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1714_6105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.0537 29.13) rotate(111.224) scale(46.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.820788,
    stopColor: "#5E3F77",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60407C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1714_6105",
    x1: 59.6588,
    y1: 24.3689,
    x2: 21.5904,
    y2: 50.5276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6943B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159269,
    stopColor: "#DFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641607,
    stopColor: "#F4C52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C03C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1714_6105",
    x1: 57.9567,
    y1: 24.7942,
    x2: 22.8657,
    y2: 52.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517369,
    stopColor: "#FFD941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE42"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1714_6105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4837 25.1665) rotate(110.76) scale(3.12773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471923,
    stopColor: "#FF4E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6453D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1714_6105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.7241 52.9731) rotate(110.76) scale(3.12773 3.12773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471923,
    stopColor: "#FF4E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6453D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1714_6105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5558 43.0844) rotate(110.76) scale(3.12773 3.12773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471923,
    stopColor: "#FF4E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6453D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1714_6105",
    x1: 52.8531,
    y1: 33.0977,
    x2: 51.4378,
    y2: 46.4647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#539253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72AB42"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1714_6105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1085 44.9981) rotate(94.2947) scale(8.9574 3.69033)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E43C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96E839",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1714_6105",
    x1: 40.9705,
    y1: 25.6065,
    x2: 23.3187,
    y2: 30.4979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.793475,
    stopColor: "#9E7830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7830",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1714_6105",
    x1: 41.0494,
    y1: 25.7511,
    x2: 23.3979,
    y2: 30.6426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.793475,
    stopColor: "#D5AB3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AB3E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1714_6105",
    x1: 39.492,
    y1: 26.5769,
    x2: 26.539,
    y2: 30.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#539253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72AB42"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1714_6105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.2459 28.7941) rotate(162.467) scale(8.80026 3.62557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E43C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96E839",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1714_6105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6463 26.469) rotate(154.654) scale(1.1178 1.03263)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AD291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88CF90",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1714_6105",
    x1: 37.22,
    y1: 25.9536,
    x2: 28.3953,
    y2: 29.2604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74AD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9F270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1714_6105",
    x1: 40.6359,
    y1: 55.4102,
    x2: 31.0609,
    y2: 45.6688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#539253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72AB42"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1714_6105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7134 46.2741) rotate(-133.531) scale(8.80026 3.62557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E43C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96E839",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1714_6105",
    x1: 52.4283,
    y1: 35.2151,
    x2: 52.4283,
    y2: 44.3601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89D18E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9F270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1714_6105",
    x1: 36.8267,
    y1: 25.9287,
    x2: 28.6094,
    y2: 29.9423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67B35B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CCD45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1714_6105",
    x1: 40.2,
    y1: 52.4101,
    x2: 34.7766,
    y2: 46.6995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89D18E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9F270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1714_6105",
    x1: 26.482,
    y1: 30.2441,
    x2: 29.1538,
    y2: 29.5557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B9134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9134",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1714_6105",
    x1: 31.5343,
    y1: 45.5841,
    x2: 33.3875,
    y2: 47.6281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79A53B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9134",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1714_6105",
    x1: 50.8963,
    y1: 46.0499,
    x2: 51.3714,
    y2: 43.3321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79A53B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9134",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1714_6105",
    x1: 48.918,
    y1: 16.0746,
    x2: 65.1876,
    y2: 38.5114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C05B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186928,
    stopColor: "#FFD874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454689,
    stopColor: "#E7B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727425,
    stopColor: "#FFD07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BF5F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodQuality);
export default __webpack_public_path__ + "static/media/food_quality.c74c184694c983455303371faf8ca2e8.svg";
export { ForwardRef as ReactComponent };